// [에이전트 설정 열기] — 웹↔에이전트 다리 3종 ① (2026-08-20 대표 승인)
// 에이전트 계약(alpha.38, dev-agent): agentCommands type 'open_settings'
//   { labId, targetDeviceId, payload: { section: 'cad' | 'outsource' | 'scan' }, status: 'pending' }
// - 에이전트가 pending 명령을 집어 해당 설정 화면을 연다. 구버전은 명령을 모른 채 24h 만료로 소멸(부작용 없음).
// - rules 배포 전엔 create가 permission-denied — 호출부는 'not_supported'를 받아
//   "프로그램 업데이트 후 지원됩니다" 안내로 조용히 처리한다 (빈 catch 금지, 콘솔에 코드 기록).
import { addDoc, collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const ONLINE_MIN = 15; // 🟢 판정 기준(분) — AgentDevices와 동일 (하트비트 5분 × 여유 3배)

function toMs(t) {
    if (!t) return 0;
    if (typeof t.toMillis === 'function') return t.toMillis();
    if (typeof t.toDate === 'function') return t.toDate().getTime();
    const d = new Date(t);
    return isNaN(d) ? 0 : d.getTime();
}

// 대상 PC 자동 선택 — 온라인(15분 내 하트비트) PC 우선, 없으면 가장 최근에 신호 보낸 PC (계약: "온라인 PC 우선")
export function pickTargetDeviceId(statusData) {
    const list = Object.values(statusData?.devices || {}).filter(d => d && d.deviceId);
    if (!list.length) return null;
    const sorted = list
        .map(d => ({ id: d.deviceId, ms: toMs(d.lastSeen) }))
        .sort((a, b) => b.ms - a.ms);
    const online = sorted.find(d => d.ms && (Date.now() - d.ms) / 60000 <= ONLINE_MIN);
    return (online || sorted[0]).id;
}

// open_settings 명령 생성. targetDeviceId를 안 주면 agentStatus에서 자동 선택.
// 반환: { ok:true, deviceId } | { ok:false, reason: 'no_device' | 'not_supported' | 'error', error? }
export async function sendOpenSettings({ labId, section, targetDeviceId, requestedBy }) {
    if (!labId) return { ok: false, reason: 'no_device' };
    let devId = targetDeviceId || '';
    if (!devId) {
        try {
            const st = await getDoc(doc(db, 'agentStatus', labId));
            devId = st.exists() ? pickTargetDeviceId(st.data()) : null;
        } catch (e) {
            console.error('[에이전트 설정 열기] 대상 PC 조회 실패:', e?.code || e?.message);
        }
    }
    if (!devId) return { ok: false, reason: 'no_device' };
    try {
        await addDoc(collection(db, 'agentCommands'), {
            labId,
            type: 'open_settings',
            targetDeviceId: devId,
            payload: { section: section || 'cad' },
            status: 'pending',
            requestedBy: requestedBy || '',
            createdAt: new Date(),
        });
        return { ok: true, deviceId: devId };
    } catch (e) {
        // rules 배포 전(type 화이트리스트 미포함) permission-denied → 업데이트 안내로 처리
        console.error('[에이전트 설정 열기] 명령 생성 실패:', e?.code || e?.message);
        return e?.code === 'permission-denied'
            ? { ok: false, reason: 'not_supported', error: e?.code }
            : { ok: false, reason: 'error', error: e?.code || e?.message };
    }
}

// 결과별 안내 문구 (호출부 공통)
export const OPEN_SETTINGS_MSG = {
    ok: '덴클 프로그램에 설정 화면을 열도록 요청했습니다 — 해당 PC가 켜져 있으면 곧 열립니다. (프로그램이 최신이어야 합니다)',
    no_device: '연결된 PC를 찾지 못했습니다 — 덴클 프로그램을 실행하고 로그인한 뒤 다시 시도해주세요.',
    not_supported: '이 기능은 덴클 프로그램 업데이트 후 지원됩니다.',
    error: '요청에 실패했습니다. 잠시 후 다시 시도해주세요.',
};
